// extracted by mini-css-extract-plugin
export default {"root":"EmptyMessage-root-c4cf2b04880ae2b1792d0bf552eb34a7"};